import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { Box } from '@mui/material';

import BlockViewLabel from './BlockViewLabel';
import { TFlatBlock } from './helpers/blocksToFlatDocument';

type Props = {
  flatBlock: TFlatBlock | null | undefined;
};
export default function GhostBlockView({ flatBlock }: Props) {
  if (!flatBlock) {
    return null;
  }
  return createPortal(<ActiveGhostBlockView flatBlock={flatBlock} />, document.body);
}

function ActiveGhostBlockView({ flatBlock }: { flatBlock: TFlatBlock }) {
  const [positionX, setPositionX] = useState(0);
  const [positionY, setPositionY] = useState(0);
  useEffect(() => {
    const handleMove = (ev: MouseEvent) => {
      setPositionX(ev.clientX);
      setPositionY(ev.clientY);
    };
    window.addEventListener('mousemove', handleMove);
    return () => window.removeEventListener('mousemove', handleMove);
  }, []);

  return (
    <Box
      sx={{
        transform: 'translate(24px, 0)',
        opacity: 0.8,
        position: 'absolute',
        zIndex: 15000,
        top: positionY - 20,
        left: positionX - 100,
      }}
    >
      <BlockViewLabel flatBlock={flatBlock} />
    </Box>
  );
}
